import { editDataAxiosPut, fetchDataAxios } from "./services";

/**
 * Thin API helpers for Phase 3 user application state.
 * Failures are left to the caller so persistence never blocks navigation.
 */

export const fetchUserAppState = async () => {
  const response = await fetchDataAxios("/user-app-state");
  return response?.data ?? null;
};

export const saveUserAppStateRoute = async ({ route, module }) => {
  const response = await editDataAxiosPut("/user-app-state/route", {
    route,
    module,
  });
  return response?.data ?? null;
};

export const saveUserAppStatePreferences = async (preferences) => {
  const response = await editDataAxiosPut("/user-app-state/preferences", {
    preferences,
  });
  return response?.data ?? null;
};
